/* eslint-disable import/prefer-default-export */
import { injectLocal } from '@vueuse/core';
import { ref, readonly } from 'vue';

import {
  FREQUENCY_KEY_REPOSITORY,
  SHIP_OPTIONS,
  SHIPS,
} from '../constants';

/**
 * * This composable is used to manage the auto replenishment feature
 *
 * @desription
 * Allows the user to subscribe to receive a product at a regular interval.
 * For example, a user can subscribe to receive a product every 30 days.
 * For now 30, 60, 90 and 120 days are the only options available. @see {SHIPS}
 * {@link file://./useAutoReplenishment.js}
 * {@link file://./Readme.md}
 *
 * @example
 * ```js
 * import { useAutoReplenishment } from '@composables/useAutoReplenishment';
 *
 * const {
 *  autoReplenishmentEnabled,
 *  frequency,
 *  frequencySelected,
 *  frequencyOptions,
 * } = useAutoReplenishment();
 * ```
 */
export const useAutoReplenishment = () => {
  /**
   * @type {{
   *  frequency: import('vue').Ref<SHIPS>,
   *  autoReplenishmentEnabled: import('vue').Ref<boolean>,
   *  frequencySelected: import('vue').ComputedRef<boolean>
   * }}
   */
  const { frequency, autoReplenishmentEnabled, frequencySelected } = injectLocal(FREQUENCY_KEY_REPOSITORY, () => ({
    frequency: readonly(ref(SHIPS.NONE)),
    autoReplenishmentEnabled: readonly(ref(false)),
    frequencySelected: readonly(ref(false)),
  }), true); // Provides fallback values to avoid undefined values to prevent possible errors

  return {
    autoReplenishmentEnabled,
    frequency,
    frequencySelected,
    frequencyOptions: SHIP_OPTIONS,
  };
};
